import { useDispatch, useSelector } from "react-redux";
import { toast } from "sonner";
import { Drink, containers } from "src/lib/db";
import { getDrinkById } from "src/lib/hooks/useGetDrinkById";
import { DrinkCache } from "src/lib/slices/drinkCache";
import {
  getSelectedContainer,
  selectContainer,
  selectDrink,
} from "src/lib/slices/drinkSelectionSlice";
import { selectDefaultContainer } from "src/lib/slices/userSlice";
import { AlcDrawer, DrawerTitle } from "../ui/drawer";
import DrinkSearch from "./DrinkSearch";
import DrinkTabs from "./DrinkTabs";

export default function DrinkDrawer({
  drinkSelectionOpen,
  setDrinkSelectionOpen,
  selection,
  selectedDrink,
}) {
  const dispatch = useDispatch();

  const user = useSelector((state: any) => state.user);

  const ownDrinks: Drink[] = useSelector((state: any) => state.ownItems.Drinks);

  const drinkCache: DrinkCache = useSelector((state: any) => state.drinkCache);

  const selectDrinkHandler = (drinkId, newlyCachedDrink?: Drink) => {
    dispatch(selectDrink(drinkId));
    setDrinkSelectionOpen(false);
    const drink =
      newlyCachedDrink ?? getDrinkById(drinkId, ownDrinks, drinkCache);
    const defaultContainer = selectDefaultContainer({
      drinkId: drinkId,
      containerId: drink.defaultContainerId,
    })(user);
    if (!defaultContainer || selection.containerId === defaultContainer) return;
    const container = getSelectedContainer({
      containerId: defaultContainer,
    });
    if (containers.find((c) => c.id === defaultContainer) === undefined) return;
    toast(`Přepnout na výchozí nádobu na ${drink.name}?`, {
      description: `${container.name} ${container.volume} ${container.units}`,
      action: {
        label: "Ano",
        onClick: () => {
          dispatch(selectContainer(defaultContainer));
        },
      },
    });
  };

  return (
    <AlcDrawer
      isOpen={drinkSelectionOpen}
      setIsOpen={setDrinkSelectionOpen}
      header={
        <>
          <DrawerTitle style={{ paddingBottom: "1rem" }}>
            Výběr Nápoje
          </DrawerTitle>
          <DrinkSearch
            open={drinkSelectionOpen}
            setOpen={setDrinkSelectionOpen}
            selectDrink={selectDrinkHandler}
          />
        </>
      }
    >
      <DrinkTabs
        selection={selection}
        open={drinkSelectionOpen}
        setOpen={setDrinkSelectionOpen}
        selectDrink={selectDrinkHandler}
        selectedDrink={selectedDrink}
      />
    </AlcDrawer>
  );
}
